import React from 'react';
import classNames from 'classnames';
import StyledLabel from '../../styled-label';

const namespace = 'ui-pdp-inspection-vehicles-tag';

/**
 * Generates the content for the inspection tooltip.
 *
 * @param {Object} body - The properties to be spread into the StyledLabel component.
 * @param {string} type - The type of inspection badge tooltip content.
 * @returns {JSX.Element} The JSX element representing the inspection tooltip content.
 */
export function getInspectionTooltipContent(body, type) {
  return <StyledLabel className={classNames(`${namespace}__inspection-badge-tooltip-content`, type)} {...body} />;
}
